export default __webpack_public_path__ + "static/media/erro.f60c52a1.svg";